'use strict';
import utils from './../utils.js';
export default function isAxiosError(payload) {
    return utils.isObject(payload) && payload.isAxiosError === true;
}